<template>
  <div class="msg"></div>
</template>

<script>
class ScopedContent extends HTMLElement {
  constructor(html) {
    super();
    // Attach a shadow root to the element.
    const shadow = this.attachShadow({ mode: "open" });
    shadow.innerHTML = html;
  }
}
customElements.define("scoped-content", ScopedContent);
export default {
  props: ["html"],
  mounted() {
    // Define the new element

    // Use the new custom element
    this.$el.appendChild(new ScopedContent(this.html));
  },
};
</script>

<style lang="scss" scoped>
.msg {
  min-height: 150px;
  padding: 15px 10px;
  background-color: white;
  border-radius: 5px;
  background: #fff;
  box-shadow: 2px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  justify-content: center;
  flex-direction: column;
  //max-height: 400px;
  overflow: auto;
  align-items: center;
  display: flex;
  transition: all 0.2s ease-out;
}
</style>
